import React, { useState, useEffect } from "react";
import styles from "./userManagement.module.css";

import { useAuth } from "../../Context/AuthContext";
import { fetchAllUsers, fetchUsers } from "../../Api/Backend/User";


export default function UserList({ onEditEntry }) {
  const auth = useAuth();

  const authorityTypes = ["GUEST", "AUTHOR", "MANAGER", "ADMIN"];
  const [filterType, setFilterType] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const [listData, setListData] = useState([]);

  const handleFetchUsers = async () => {
    await fetchUsers({
      auth: auth,
      authorityType: filterType,
      email: searchTerm,
      onSuccess: (data) => {
        setListData(data);
      },
      onError: (error) => {
        console.log("Error: ", error);
        setListData([]);
      }
    })
  };

  useEffect(() => {
    console.log(
      `Fetching data for type: ${filterType} and term: ${searchTerm}`
    );

    handleFetchUsers();
  }, [filterType]);

  const headers = [
    { key: "email", label: "이메일" },
    { key: "authorityType", label: "권한 유형" },
    { key: "name", label: "이름" },
    { key: "phoneNumber", label: "전화번호" },
    { key: "authMethod", label: "인증 방식" },
  ];

  return (
    <div className={styles.listContainer}>
      <div className={styles.filterBar}>
        <div className={styles.filterGroup}>
          <label>권한 유형</label>
          <select
            value={filterType}
            onChange={(e) => setFilterType(e.target.value)}
          >
            <option value="">모두</option>
            {authorityTypes.map((value, index) => (
              <option key={index} value={value}>{value}</option>
            ))}
          </select>
        </div>
        <div className={styles.filterGroup}>
          <label>이메일</label>
          <input
            type="text"
            placeholder="username@naver.com..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>
        <button className={styles.searchButton} onClick={handleFetchUsers}>검색</button>
      </div>

      <div className={styles.tableContainer}>
        <table className={styles.table}>
          <thead>
            <tr>
              {headers.map(({ key, label }) => (
                <th key={key}>{label}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {listData.map((item) => (
              <tr key={item.userId} onClick={() => onEditEntry(item)}>
                {headers.map(({ key }) => (
                  <td key={`${item.userId}-${key}`}>{item[key]}</td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
